/**
 * Scope for which the workflow definition override should be applied.
 */
export var WorkflowDefinitionScope;
(function (WorkflowDefinitionScope) {
    /**
     * Apply only for the context in which the workflow is currently executing.
     * Context is currently only supported for Join workflows.
     */
    WorkflowDefinitionScope[WorkflowDefinitionScope["JoinContext"] = 0] = "JoinContext";
    /**
     * Apply for the whole session lifetime.
     */
    WorkflowDefinitionScope[WorkflowDefinitionScope["Session"] = 1] = "Session";
})(WorkflowDefinitionScope || (WorkflowDefinitionScope = {}));
/**
 * Specifying this exception in workflow actions done method will result in workflow execution reported as successful in AL metrics/monitoring.
 * AL team does not get notified of ExpectedError's unlike other reported errors which (if happen frequently enough) show up on our dashboards/monitoring.
 * If enough expected errors happen in a session the scenario (workflow) will be marked as yellow in scenario health metric for the session.
 */
export class ExpectedError extends Error {
    constructor(message = 'ExpectedError') {
        super(message);
        this.__proto__ = ExpectedError.prototype;
    }
}
//# sourceMappingURL=iworkflow.js.map